export const ENDPOINT_PORTIONS = {
  CONFIRM_EMAIL: 'confirm-email',
  CHANGE_PASSWORD: 'change-password'
};

export const VERIFICATION_TYPES = {
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD'
};
